export default __webpack_public_path__ + "static/media/10-TheBoathouse.0192fb14.jpeg";